type LocalizeUtilsReturnTypes = {
  getLocalizationMessagesByCountryAndLanguage: (
    country: string, language: string,
  ) => Record<string, string>;
  getMessageByCountryAndLocale: (
    country: string,
    language: string,
    id: string,
  ) => string;
};

export const localizeUtils: LocalizeUtilsReturnTypes = {
  getLocalizationMessagesByCountryAndLanguage(country: string, language: string) {
    return require(`../../messages/${CONFIG.applicationSiteGroup}/${language}-${country}.json`);
  },
  getMessageByCountryAndLocale(country: string, language: string, id: string) {
    const localizationMessages = localizeUtils.getLocalizationMessagesByCountryAndLanguage(
      country,
      language,
    );
    return localizationMessages[id];
  },
};
